/**
 * FilterChip
 * @module components/FilterChip
 */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from 'context/localization.context';
import Icon from '../Icon';

const FilterChip = ({ name, facetId, item, onDelete }) => {
	const { t } = useContext(LocalizationContext);
	return (
		<li className="group">
			<button
				onClick={(e) => {
					e.preventDefault();
					onDelete(facetId, item.id, false);
				}}
				title={`${t('shared/filter/removefilter')} ${name}`}
				className="flex items-center gap-1 bg-pastelGreen rounded-lg text-sm px-2 py-1"
			>
				<span>{name}</span>
				<span className="font-bold">{item.name}</span>
				<Icon icon="clear" className="text-white ml-1 group-hover:text-black" />
			</button>
		</li>
	);
};

FilterChip.propTypes = {
	name: PropTypes.string,
	item: PropTypes.shape({
		id: PropTypes.string,
		count: PropTypes.number,
		name: PropTypes.string,
	}),
};

export default FilterChip;
